export const API_HOST = "https://erp.ssiaeration.com"